<template>
    <div class="tool-content">
        <div class="left-tool">
            <div class="tool-item" @click="viewRecording" :class="{ current: dialog_view_title === '录音' }" v-if="isShow.recording">
                <i class="iconfont">&#xe670;</i>
                <!-- <span class="tool-text">录音</span> -->
            </div>
            <div class="tool-item" @click="viewLink"  :class="{ current: dialog_view_title === '链接' }" v-if="isShow.link">
                <i class="iconfont">&#xe66e;</i>
                <!-- <span class="tool-text">链接</span> -->
            </div>
            <div class="tool-item" @click="viewResources"  :class="{ current: dialog_view_title === '配套材料' }" v-if="isShow.material">
                <i class="iconfont">&#xe66f;</i>
                <!-- <span class="tool-text">配套材料</span> -->
            </div>
        </div>
        <!--查看工具弹窗-->
        <el-dialog :visible.sync="viewToolDialog" width="1014px" :close-on-click-modal="false" class="add-tool-dialog" top="6vh"
                   append-to-body @close="handleCloseTool">
            <div class="dialog-header" slot="title">
                <span class="left">查看{{dialog_view_title}}</span>
                <span class="center">{{course_name}}第{{zhangIndex+1}}章第{{jieIndex+1}}节</span>
            </div>
            <div class="dialog-content">
                <div class="content-item view-recording-item" v-if="dialog_view_title === '录音'">
                    <!-- <div class="select type-list">
                        <span class="select-text">音乐：</span>
                        <el-select v-model="recordingValve" placeholder="请选择" style="width: 300px" clearable
                                   @change="selectRecording">
                            <el-option
                                    v-for="item in recordingList"
                                    :key="item.id"
                                    :label="item.data.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div> -->
                    <!-- <div class="content" v-if="recordingUrl !==''">
                        <audio controls>
                            <source :src="recordingUrl" type="audio/ogg">
                        </audio>
                    </div> -->
                    <template v-for="item in recordingList">
                        <audioModule :audioName="item.data.name" :audioSrc="item.data.url.url" style="margin-top: 24px; box-sizing: border-box;"/>
                    </template>
                    <div class="content" v-if="!recordingList.length">
                        <div class="no-data">
                            <img src="../../assets/images/no-data.png">
                        </div>
                    </div>
                </div>
                <div class="content-item view-link-item" v-if="dialog_view_title === '链接'">
                    <!-- <div class="select type-list">
                        <span class="select-text">名称：</span>
                        <el-select v-model="linkValve" placeholder="请选择" style="width: 300px" clearable
                                   @change="selectLink">
                            <el-option
                                    v-for="item in linkList"
                                    :key="item.id"
                                    :label="item.data.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="content" v-if="linkUrl !==''">
                        <a :href="linkUrl" target="_blank">{{linkUrl}}</a>
                    </div> -->
                    <div style="padding: 24px 40px; display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 24px">
                        <div v-for="item in linkList" style="height: 50px; background: #F2F6FA; border-radius: 8px; border: 1px solid #E1E6F0; padding: 20px; display: flex; flex-direction: column; justify-content: space-between;">
                            <div style="font-size: 16px; color: #333;" class="single-line">{{ item.data.name }}</div>
                            <div style="color: #8F8F8F; cursor: pointer;" class="single-line" @click="openUrl(item.data.url)">{{ item.data.url }}</div>
                        </div>
                    </div>
                    <div class="content" v-if="linkUrl ===''">
                        <div class="no-data">
                            <img src="../../assets/images/no-data.png">
                        </div>
                    </div>
                </div>
                <div class="content-item resources-item" v-if="dialog_view_title === '配套材料'">
                    <div class="select type-list">
                        <span class="select-text">类型：</span>
                        <!-- <el-select v-model="typeValve" placeholder="请选择" style="width: 300px" clearable
                                   @change="selectShowType">
                            <el-option
                                    v-for="item in typeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select> -->
                        <span v-for="item in typeList" style="margin-left: 24px; color: #333; cursor: pointer;" :style="{ color: typeValve === item.id? '#006EFF' : '' }" @click="selectShowType(item.id)">{{ item.name }}</span>
                    </div>
                    <div class="content" v-if="addedMaterialLists.length">
                        <div class="right-list" :style="suffix == 'avi' || suffix == 'mp4' ? { display: 'flex', 'align-items': 'center', background: '#000' } : ''">
                            <div v-if="suffix == 'avi' || suffix == 'mp4'" style="height: 100%;">
                                <video v-if="addedMaterialLists.length > 0" :src="added_material_content" width="100%" height="100%"
                                    class="iframe-content" autoplay controls id="myVideo"></video>
                            </div>
                            <div style="height:100%" v-if="!['avi', 'mp4', 'zip', 'rar'].includes(suffix)">
                                <iframe v-if="addedMaterialLists.length > 0" :src="added_material_content" width="100%" height="100%"  frameborder="0"
                                    class="iframe-content"></iframe>
                            </div>
                            <div style="height:100%; display: flex; flex-direction: column; align-items: center; justify-content: center;" v-if="['zip', 'rar'].includes(suffix)">
                                <img src="../../assets/images/no-file.png">
                                <div>
                                    <span>{{ currentFile.data ? currentFile.data.title : currentFile.title }}</span>
                                    <span>.{{ currentFile.data ? currentFile.data.resource_file_type : currentFile.resource_file_type }}</span>
                                    <i @click="filePreview(currentFile)" class="iconfont" style="cursor: pointer; color: #006EFF; margin-left: 12px;">&#xe6be;</i>
                                </div>
                            </div>
                            <div @click="fullScreen(currentFile)" style="position: absolute; bottom: 12px; right: 16px; font-size: 16px; color: #fff; padding: 6px 8px; background: rgba(0,0,0,0.5); border-radius: 4px; cursor: pointer;" v-if="!['avi', 'mp4', 'zip', 'rar'].includes(suffix)">
                                <i class="iconfont">&#xe7cf;</i>
                                <span style="margin-left: 4px;">全屏</span>
                            </div>
                        </div>
                        <el-scrollbar class="left-list" :native="false" v-if="addedMaterialLists.length">
                            <div class="type-item" v-for="item in addedMaterialLists" :title="item.data.title" @click="selectTypeMaterial(item)">
                                <div style="width: 14px; text-align: right; margin-right: -3px;">
                                    <i class="iconfont" style="color: #006EFF; " v-if="currentItem === item.data.resource_id">&#xe7ad;</i>
                                </div>
                                <div class="text-box" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block; width: 214px;" :class="{ current: currentItem === item.data.resource_id }">{{item.data.title}}</div>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div v-if="!addedMaterialLists.length" class="no-data" :style="{ width: !addedMaterialLists.length? '100%' : '247px' }">
                        <img src="../../assets/images/no-data.png">
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closePopup">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import audioModule from '@/components/teacherCourse/audioModule.vue';

    export default {
        name: "WareToolInClass",
        props: ['resource_id', 'course_name', 'zhangIndex', 'jieIndex', 'pdfPageNow', 'isShow'],
        components:{
            audioModule
        },
        data() {
            return {
                course_id: '',
                //弹窗位置
                pop_up_position: 'bottom-start',
                //是否显示添加弹窗
                addToolDialog: false,
                //选中的类型
                typeValve: 999,
                //类型类表
                typeList: [],
                typeChildLists: [],
                material_content: '',
                currentItem: '1',
                //已添加的配套材料列表
                addedMaterialLists: [],
                added_material_content: '',
                recordingFile: '',
                //是否显示查看
                viewToolDialog: false,
                //查看工具弹窗标题
                dialog_view_title: '',
                //选中的录音
                recordingValve: '',
                recordingUrl: '',
                //录音列表
                recordingList: [],
                //选中的链接
                linkValve: '',
                linkUrl: '',
                //链接列表
                linkList: [],
                videoName: '',
                videoPath: [],
                //配套材料-暂无数据
                is_no_data: false,
                suffix: '',
                currentFile: null,
            }
        },
        mounted() {
            this.course_id = this.$route.query.course_id;
            this.getTypeList();
        },
        methods: {
            openUrl(url) {
                window.open(url);
            },
            closePopup() {
                let myVideo = document.getElementById("myVideo") || null;
                if (myVideo) myVideo.pause();
                this.viewToolDialog = false
            },
            fullScreen(item) {
                let url = this.currentFile.data ? this.currentFile.data.file_preview_path.src : this.currentFile.file_preview_path.src;
                window.open(url);
            },
            filePreview(item) {
                window.open(item.data.file_path.src);
            },
            getTypeList() {
                this.$thttp.axiosGet(this.$api.meterial_mtlTypeList, (res) => {
                    if (res.code === 200) {
                        this.typeList = res.data;
                        let obj = {
                            id: 999,
                            name: '全部',
                            type: 0
                        }
                        this.typeList.splice(0, 0, obj);
                    } else {
                        this.$message.error(res.msg)
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            //选中的类型
            selectType(val) {
                this.typeValve = val;
                this.getMaterialList();
            },
            selectTypeChild(item) {
                this.currentFile = item;
                this.currentItem = item.id;
                this.getMaterialContent(item.id);
            },
            selectShowType(val) {
                this.typeValve = val;
                if (val === 999) {
                    this.getAllCourseWare();
                } else {
                    this.getCourseWare(3);
                }
            },
            selectTypeMaterial(item) {
                console.log({ item });
                this.currentFile = item;
                this.currentItem = item.data.resource_id;
                this.getAddedMaterialContent(item.data.resource_id);
            },
            //重置弹窗
            resetAddToolForm() {
                this.addToolDialog = false;
            },
            //查看工具弹窗
            viewRecording() {
                this.viewToolDialog = true;
                this.dialog_view_title = '录音';
                this.getCourseWare(1);
                console.log(this.recordingList);
            },
            viewLink() {
                this.viewToolDialog = true;
                this.dialog_view_title = '链接';
                this.getCourseWare(2);
            },
            viewResources() {
                this.viewToolDialog = true;
                this.dialog_view_title = '配套材料';
                if (this.typeValve === 999) {
                    this.getAllCourseWare();
                } else {
                    this.getCourseWare(3);
                }
            },
            getCourseWare(type) {
                let param = {
                    resource_id: this.resource_id,
                    type: type,
                    show: 'all',
                    resource_page: this.pdfPageNow
                }
                if (type === 3) {
                    param.material_type_id = this.typeValve;
                }
                this.$thttp.axiosGetBy(this.$api.courseware_showCourseWare, param, (res) => {
                    if (res.code === 200) {
                        if (type === 1) {
                            this.recordingList = res.data;
                            if (res.data.length > 0) {
                                this.recordingValve = res.data[0].id;
                                this.recordingUrl = res.data[0].data.url.url;
                            }
                        } else if (type === 2) {
                            this.linkList = res.data;
                            if (res.data.length > 0) {
                                this.linkValve = res.data[0].id;
                                this.linkUrl = res.data[0].data.url;
                            }
                        } else {
                            this.addedMaterialLists = res.data;
                            this.addedMaterialLists.map(item => {
                                if(item.data.material_id) item.data.resource_id = item.data.material_id;
                            })
                            if (res.data.length > 0) {
                                this.is_no_data = false;
                                this.currentFile = res.data[0].data;
                                this.currentItem = res.data[0].data.resource_id;
                                this.getAddedMaterialContent(res.data[0].data.resource_id);
                            } else {
                                this.is_no_data = true;
                            }
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            //获取所有配套材料
            getAllCourseWare() {
                let param = {
                    resource_id: this.resource_id,
                    type: 3,
                    show: 'all',
                    resource_page: this.pdfPageNow
                }
                this.$thttp.axiosGetBy(this.$api.courseware_showCourseWare, param, (res) => {
                    if (res.code === 200) {
                        this.addedMaterialLists = res.data;
                        this.addedMaterialLists.map(item => {
                            if(item.data.material_id) item.data.resource_id = item.data.material_id;
                        })
                        if (res.data.length > 0) {
                            this.is_no_data = false;
                            this.currentFile =res.data[0].data;
                            this.currentItem = res.data[0].data.resource_id;
                            this.getAddedMaterialContent(res.data[0].data.resource_id);
                        } else {
                            this.is_no_data = true;
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            handleCloseTool() {
                this.recordingList = [];
                this.linkList = [];
                this.recordingUrl = '';
                this.linkUrl = '';
                this.recordingValve = '';
                this.linkValve = '';
                this.typeValve = 999;
                this.closePopup();
            },
            //选中的录音
            selectRecording(val) {
                this.recordingList.forEach(item => {
                    if(item.id === val){
                        this.recordingUrl = item.data.url.url;
                    }
                })
                if(val === ''){
                    this.recordingUrl = ''
                }
            },
            //选中的链接
            selectLink(val) {
                this.linkList.forEach(item => {
                    if(item.id === val){
                        this.linkUrl = item.data.url;
                    }
                })
                if(val === ''){
                    this.linkUrl = ''
                }
            },
            //获取配套材料列表
            getMaterialList() {
                let param = {
                    course_id: this.$route.query.course_id,
                    course_chapter: this.zhangIndex,
                    course_node: this.jieIndex,
                    type: 'all'
                }
                if (this.typeValve !== 999) {
                    param.meterial_type_id = this.typeValve;
                }
                this.$thttp.axiosGetBy(this.$api.meterial_showMeterialList, param, (res) => {
                    if (res.code === 200) {
                        this.typeChildLists = res.data;
                        if (res.data.length > 0) {
                            this.is_no_data = false;
                            this.currentFile = res.data[0];
                            this.currentItem = res.data[0].id;
                            this.getMaterialContent(res.data[0].id);
                        } else {
                            this.is_no_data = true;
                        }
                    } else {
                        this.$message.error(res.msg)
                    }
                }, (err) => {
                    console.log(err);
                })
            },
            //获取配套材料对应资源
            getMaterialContent(id) {
                this.typeChildLists.forEach((item) => {
                    if (item.id === id) {
                        this.material_content = item.file_path.url;
                    }
                })
            },
            //获取已添加对的配套材料对应资源
            getAddedMaterialContent(id) {
                this.addedMaterialLists.forEach((item) => {
                    if (item.data.resource_id === id) {
                        this.added_material_content = item.data.file_preview_path.url;
                    }
                    if(item.data.material_id) item.data.resource_id = item.data.material_id;
                })
                this.suffix = this.added_material_content.substring(this.added_material_content.lastIndexOf('.') + 1);
            }
        }
    }
</script>

<style scoped lang="scss">
    .left-tool {
        box-sizing: border-box;
        z-index: 999;
        width: 48px;
        // height: 144px;
        padding: 0 10px;
        background-color: #fff;
        box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.08), 0px 16px 24px 2px rgba(0,0,0,0.04), 0px 6px 30px 5px rgba(0,0,0,0.05);
        position: absolute;
        right: 130px;
        bottom: 30px;
        // padding-top: 80px;
        .tool-item {
            box-sizing: border-box;
            cursor: pointer;
            color: #333;
            width: 100%;
            height: 48.5px;
            text-align: center;
            display: flex;
            // flex-direction: column;
            justify-content: center;
            align-items: center;
            // padding: 0 12px;
            border-bottom: 1px solid #E5E5E5;
            i.iconfont {
                // margin-bottom: 10px;
                font-size: 26px;
            }
            &.current {
                color: #333;
                background: #fff;
            }
        }
    }
    .add-tool-dialog {
        ::v-deep .el-dialog__header {
            color: #fff;
            font-size: 16px;
            color: #606266;
            .dialog-header {
                display: flex;
                position: relative;
                .center {
                    position: absolute;
                    display: inline-block;
                    text-align: center;
                    width: 100%;
                    font-weight: 550;
                }
            }
            ::v-deep .el-dialog__headerbtn .el-dialog__close {
                color: #fff;
            }
        }
        ::v-deep .el-dialog__footer {
                border-top: 1px solid #E6E7EB;
            }
        ::v-deep .el-dialog__body {
            /*height: 467px;*/
            padding: 0 0 24px 0;
            .dialog-content {
                height: 100%;
                // background-color: #F2F2F2;
                padding: 0 30px;
                overflow-y: auto;
                .content-item {
                    display: flex;
                    flex-direction: column;
                }
                .resources-item {
                    height: 500px;
                }
                .recording-item {
                    background-color: #fff;
                    height: 267px;
                }
                .view-recording-item {
                    height: 500px;
                    .content {
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        margin-top: 13px;
                        background-color: #fff;
                        .recording-name {
                            height: 60px;
                        }
                    }
                }
                .view-link-item {
                    background-color: #fff;
                    height: 500px;
                    .content {
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        background-color: #fff;
                        margin: 20px;
                    }
                }
                .type-list {
                    display: flex;
                    align-items: center;
                    // height: 80px;
                    background-color: #fff;
                    // padding: 0 20px;
                    padding: 30px 30px 0 30px;
                }
                .content {
                    display: flex;
                    flex: 1;
                    height: 1%;
                    padding: 30px 30px 6px 30px;
                    background: #fff;
                    .left-list {
                        width: 247px;
                        height: 100%;
                        background-color: #fff;
                        ::v-deep .el-scrollbar__wrap {
                            overflow: auto;
                            .el-scrollbar__view {
                                height: 100%;
                            }
                        }
                        .type-item {
                            display: flex;
                            align-items: center;
                            margin-bottom: 6px;
                            .text-box {
                                border-radius: 4px;
                                border: 1px solid #DDDDDD;
                                height: 34px;
                                line-height: 34px;
                                padding: 0 10px;
                                color: #333;
                                font-size: 14px;
                                cursor: pointer;
                            }
                        }
                        .current {
                            border-color: #006EFF !important;
                            color: #000000 !important;
                        }
                    }
                    .right-list {
                        flex: 1;
                        width: 1%;
                        box-sizing: border-box;
                        background: #F2F6FA;
                        border-radius: 4px;
                        border: 1px solid #E1E6F0;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                    }
                }
            }
        }
    }
    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        margin-top: 24px;
    }
    .single-line {
        width: 170px;
        white-space: nowrap; 
        overflow: hidden;
        text-overflow:ellipsis;
    }
</style>